import {ConversionFactorsComponent} from '../../../../../../pages';
import {TenderAnalyticsConversionFactorResolver, TenderAnalyticsCurrencyRatesResolver} from '../../../../../resolvers';
import { Route } from '@angular/router';

export const conversionFactorsRoute: Route = {
    path: 'conversion-factors',
    component: ConversionFactorsComponent,
    resolve: {
        conversion_factor: TenderAnalyticsConversionFactorResolver,
        analytic_currency_rates: TenderAnalyticsCurrencyRatesResolver
    },
};
